import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import AppPaths from '../../AppPaths';
import { ReactComponent as CloseIcon } from '../../assets/images/close-navigation.svg';
import useDefaultProduct from '../../hooks/useDefaultProduct';
import { getDomainConfig } from '../../lib/domainConfig';
import * as types from '../../types';
import { series3CollarId, ProductCategory } from '../../types';
import Breadcrumbs from '../Breadcrumbs';
import styles from './AppBar.module.scss';
import LoginLogoutButton from './LoginLogoutButton';
import { getFiGrowthBook, useIsGrowthBookEnabled } from '../../lib/growthbook';
import { useTranslation } from 'react-i18next';

interface IMainNavigationProps {
  dismissMobileMenu(): void;
}

function MainNavigation({ dismissMobileMenu }: IMainNavigationProps) {
  const isReseller = useSelector((state: types.AppState) => state.config.siteConfig.isReseller);
  const defaultProduct = useDefaultProduct();

  const seriesThreePlusExperience = useIsGrowthBookEnabled()
    ? getFiGrowthBook().getFeatureValue<boolean>('series-three-plus-experience', false)
    : false;

  const { t } = useTranslation();
  const { baseDomain, shopDomain, blogDomain } = getDomainConfig();
  const NavLinks = [
    { path: `https://${baseDomain}/collar`, text: t('collar') },
    { path: `https://${baseDomain}/theapp`, text: t('app') },
    { path: `https://${baseDomain}/learn`, text: t('difference') },
    { path: `https://${baseDomain}/membership`, text: t('membership') },
    { path: `https://${shopDomain}/products/supplements`, text: t('supplements') },
    { path: `https://${shopDomain}/accessories`, text: t('accessories') },
    { path: `https://${blogDomain}`, text: t('blog') },
  ];

  return (
    <div className={styles.nav}>
      <div className={styles.close}>
        <button type="button" aria-label={t('close')} className={styles.iconButton} onClick={dismissMobileMenu}>
          <CloseIcon style={{ fill: 'black' }} className={styles.toggle} />
        </button>
      </div>
      <div className={styles.container}>
        <div className={classNames(styles.linkGroup, styles.checkoutLinks)}>
          <Breadcrumbs />
        </div>
        <div className={classNames(styles.linkGroup, styles.storeLinks)}>
          {isReseller && defaultProduct.category === ProductCategory.MICROCHIP && (
            <Link to={AppPaths.Products(defaultProduct.id)} className={styles.link} onClick={dismissMobileMenu}>
              {t('fi_nano')}
            </Link>
          )}
          <Link to={AppPaths.Products(series3CollarId)} className={styles.link} onClick={dismissMobileMenu}>
            {seriesThreePlusExperience ? t('series_3_plus') : t('series_3')}
          </Link>

          <Link to={AppPaths.Accessories} className={styles.link} onClick={dismissMobileMenu}>
            {t('accessories')}
          </Link>
          <Link to={AppPaths.Gift} className={styles.link} onClick={dismissMobileMenu}>
            {t('gift_cards')}
          </Link>
        </div>
        <div className={classNames(styles.linkGroup, styles.marketingLinks)}>
          {NavLinks.map((link, i) => (
            <a className={styles.link} key={'link-' + i} href={link.path}>
              {link.text}
            </a>
          ))}
        </div>
        <div className={classNames(styles.linkGroup, styles.accountLinks)}>
          <LoginLogoutButton onClick={dismissMobileMenu} />
        </div>
      </div>
    </div>
  );
}

export default MainNavigation;
